import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Navigation } from "../../components/Navigation";
import { Lock } from "lucide-react";
import { useNoindex } from "../../hooks/useNoindex";

export const ResetPasswordPage = () => {
  useNoindex();
  const { confirmPasswordReset } = useAuth();
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Reimposta password | Edicola Cerasuolo";
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token') || "";
    setToken(t);
    if (!t) setError("Link non valido. Richiedi un nuovo link di reset.");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Le password non coincidono"); return; }
    if (password.length < 6) { setError("La password deve avere almeno 6 caratteri"); return; }
    setLoading(true);
    const result = await confirmPasswordReset(token, password);
    setLoading(false);
    if (result.success) {
      setDone(true);
    } else {
      setError(result.error || "Errore reset password");
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      <Navigation />
      <div className="max-w-md mx-auto px-4 py-12">
        <div className="bg-[#12121a] border border-gray-800 rounded-2xl p-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-500/10 rounded-full mb-4">
              <Lock className="w-8 h-8 text-amber-400" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">Reimposta password</h1>
            <p className="text-gray-500 text-sm">Scegli una nuova password per il tuo account.</p>
          </div>

          {done ? (
            <div className="text-center space-y-4" data-testid="reset-success-block">
              <div className="bg-green-500/10 border border-green-500/30 text-green-400 text-sm rounded-lg p-4">
                Password aggiornata con successo!
              </div>
              <a href="/login" className="inline-block w-full py-3 bg-amber-500 hover:bg-amber-400 text-black font-bold rounded-lg">
                Vai al login
              </a>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-password-form">
              <div>
                <label className="block text-sm text-gray-400 mb-1">Nuova password (min. 6 caratteri)</label>
                <input
                  type="password"
                  required
                  data-testid="reset-pwd-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 bg-[#0a0a0f] border border-gray-700 rounded-lg text-white focus:border-amber-500 focus:outline-none"
                />
              </div>
              <div>
                <label className="block text-sm text-gray-400 mb-1">Conferma password</label>
                <input
                  type="password"
                  required
                  data-testid="reset-confirm-input"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="w-full px-4 py-3 bg-[#0a0a0f] border border-gray-700 rounded-lg text-white focus:border-amber-500 focus:outline-none"
                />
              </div>
              {error && (
                <div data-testid="reset-error" className="bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-lg p-3">
                  {error}
                </div>
              )}
              <button
                type="submit"
                disabled={loading || !token}
                data-testid="reset-submit-btn"
                className="w-full py-3 bg-amber-500 hover:bg-amber-400 text-black font-bold rounded-lg transition disabled:opacity-60"
              >
                {loading ? 'Aggiornamento...' : 'Reimposta password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

